<template>
	<div class="thumbs-swiper">
		<div class="swi-big">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in goodsList" :key="index">
					<div class="pic">
						<img :src="item.img"
							:alt="`OCM Globe Inc - Asian food wholesale + ${item.name}, 亚洲食品批发-美国华源食品集团 + ${item.name}`">
					</div>
				</div>
			</div>
			<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div>
		</div>
		<div class="swi-small">
			<div class="swiper-wrapper">
				<div class="swiper-slide" :class="activeIndex === index ? 'thumbsActive' : ''"
					v-for="(item,index) in goodsList" :key="index">
					<div class="pic">
						<el-image style="width: 82px; height: 82px" :src="item.img" :preview-src-list="urlList"
							fit="contain"
							:alt="`OCM Globe Inc - Asian food wholesale + ${item.name}, 亚洲食品批发-美国华源食品集团 + ${item.name}`">
						</el-image>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
	name: "thumbsSwiper",
	props: {
		goodsList: [Array]
	},
	data() {
		return {
			activeIndex: 0,
			urlList: []
		};
	},
	mounted() {
		this.initSwiper();
		this.urlList = this.goodsList.map(item => item.img);
	},
	methods: {
		initSwiper: function () {
			var that = this;
			var swiper = new Swiper(".swi-small", {
				spaceBetween: 16,
				slidesPerView: 5,
				freeMode: true,
				watchSlidesProgress: true,
			});
			var swiper2 = new Swiper(".swi-big", {
				spaceBetween: 0,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				thumbs: {
					swiper: swiper,
				},
				on: {
					transitionStart: function (swiper) {
						that.activeIndex = this.activeIndex;
					}
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
.thumbs-swiper {
	overflow: hidden;
	.swi-big {
		position: relative;
		margin-bottom: 20px;
		.pic {
			padding-top: 100%;
			position: relative;
			overflow: hidden;
			img {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				object-fit: contain;
			}
		}
		.swiper-button-next,
		.swiper-button-prev {
			width: 36px;
			height: 36px;
			background: no-repeat center center / contain;
			-webkit-transition: all 0.3s;
			-moz-transition: all 0.3s;
			-ms-transition: all 0.3s;
			-o-transition: all 0.3s;
			transition: all 0.3s;
		}
		.swiper-button-prev {
			background-image: url('~@/assets/images/swi-l.png');
			left: 20px;
		}
		.swiper-button-next {
			background-image: url('~@/assets/images/swi-r.png');
			right: 20px;
		}
	}
	.swi-small {
		.pic {
			// padding-top: 100%;
			position: relative;
			overflow: hidden;
			// img {
			// 	position: absolute;
			// 	width: 100%;
			// 	height: 100%;
			// 	top: 0;
			// 	left: 0;
			// 	object-fit: contain;
			// }
			.el-image {
				display: block;
			}
		}
		.swiper-slide {
			border: 2px solid transparent;
		}
		.thumbsActive {
			border: 2px solid $black;
		}
	}
}
@media only screen and (max-width: 767px) {
	.swi-small {
		display: none;
	}
}
</style>
